"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function forTime(miliseconds) {
    return new Promise(function (resolve) {
        setTimeout(function () {
            resolve();
        }, miliseconds);
    });
}
exports.forTime = forTime;
